import { parseProjectNotes, type ChecklistItem } from "./map.js";

// The Launch Day card (Launch Day kit): who the project is for and its MVP checklist, read from
// PROJECT.md with the same conventions the project map uses.

export interface LaunchSummary {
  forWhom: string | null;
  /** The first MVP steps that fit on a card. */
  mvp: ChecklistItem[];
  /** How many MVP steps didn't fit on the card. */
  more: number;
  done: number;
  total: number;
}

export function launchSummary(files: Record<string, string>, limit = 8): LaunchSummary {
  const plan = parseProjectNotes(files["PROJECT.md"] ?? "");
  return {
    forWhom: plan.forWhom,
    mvp: plan.mvp.slice(0, limit),
    more: Math.max(0, plan.mvp.length - limit),
    done: plan.mvp.filter((m) => m.done).length,
    total: plan.mvp.length,
  };
}
